export const css = {
  checkbox:
    'form-checkbox ml-1 h-5 w-5 rounded border text-primary-300 transition-all duration-150 ease-linear',
  label: 'font-semibold text-blueGray-600 ml-2 text-sm',
};
